import { skyFoundationSettings } from '../../services/configs/configs-service';

const config = require('config');

export const VIDEO_CARD_CLASS_NAME = 'c-playlist-carousel c-video-card';
export const VIDEO_CARD_IMAGE_CONTAINER_CLASS_NAME = 'c-video-card__img-container';
export const PLAYER_CAROUSEL_ID = 'j-player-with-carousel';
export const PLAYER_CAROUSEL_CLASS_NAME = 'j-player-carousel';
export const DATA_VIDEO_ID = 'data-videoid';
export const ACTIVE_CARD_CLASS_NAME = 'c-playlist-carousel c-video-card c-video-card--offset is-active';
export const NEXT_CARD_ACTIVE_CLASS_NAME = 'c-playlist-carousel c-video-card  is-loading';
export const PLAYLIST_CAROUSEL_CONTAINER_CLASS_NAME = 'c-playlist-carousel__container';
export const PLAYLIST_CONTAINER_ID = 'video-with-carousel-section-container';
export const PROGRESS_BAR_CLASS_NAME = 'c-video-card__progress-bar';
export const BASE_PLAYLIST_ID = 'video-playlist-id-';
export const VIDEO_CAROUSEL_LOADING_CLASS_NAME = 'j-player-loading';
export const VIDEO_CAROUSEL_ERROR_MESSAGE_CLASS_NAME = 'j-player-loading-message';
export const VIDEO_CAROUSEL_LOADER_CLASS_NAME = 'j-player-loading-loader';

export const CONFIG_VIDEO_PLAYLIST = config.videoPlaylist;
export const PLAYLIST_BASE_URL = skyFoundationSettings.getPlaylistBaseUrl();

export const PROGRESS_TIMER_INTERVAL = CONFIG_VIDEO_PLAYLIST.progressTimerInterval || 50;
export const VIDEO_WAIT_TIMEOUT = CONFIG_VIDEO_PLAYLIST.videoWaitTimeout || 5000;

export const DEFAULT_PER_PAGE_ELEMENTS = 3;
export const KEY_PRESS_THROTTLE_TIME = 350;

// DOM Elements Refs used:
export const $playlistPlayerContainer = document.querySelector(`#${PLAYER_CAROUSEL_ID}`);
export const $playlistCarouselContainer = document.getElementsByClassName(PLAYLIST_CAROUSEL_CONTAINER_CLASS_NAME)[0];
export const $playerContainer = document.getElementsByClassName(PLAYER_CAROUSEL_CLASS_NAME)[0];
export const $videoCard = document.getElementsByClassName(VIDEO_CARD_CLASS_NAME);
export const $playlistContainer = document.querySelector(`#${PLAYLIST_CONTAINER_ID}`);
export const $loadingModalRef = document.querySelector(`#${VIDEO_CAROUSEL_LOADING_CLASS_NAME}`);
export const $messageRef = document.querySelector(`#${VIDEO_CAROUSEL_ERROR_MESSAGE_CLASS_NAME}`);
